module.exports = __webpack_public_path__ + "img/dynameat-logo-long.dc923145.png";